import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { UserService } from '../../services/user.service';
import { ReportService } from "../../services/report.service";
import { NotificationsService } from 'angular2-notifications';

const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}

@Component({
    selector: 'app-edit-admin-trade-master',
    templateUrl: './edit-admin-trade-master.component.html',
    styleUrls: ['./edit-admin-trade-master.component.css']
})
export class EditAdminTradeMasterDialog {
    adminTradeMasterForm: FormGroup;
    exchangeList = [];
    constructor(
        public dialogRef: MatDialogRef<EditAdminTradeMasterDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public fb: FormBuilder,
        public userService: UserService,
        private reportService: ReportService,
        public notifSer : NotificationsService
    ) { }

    async ngOnInit() {
        this.adminTradeMasterForm = this.fb.group({
            Pair: ['', [Validators.required]],
            SourceSide: ['', [Validators.required]],
            SourceUserEmail: ['', [Validators.required]],
            
            SourceTradePrice: ['', [Validators.required]],
            SourceTradeQuantity: ['', [Validators.required]],
            SourceTradeAmount: ['', [Validators.required]],

            TargetExchange: ['', [Validators.required]],

            TargetSide: ['', []],
            TargetOrderId: ['', []],
            TargetTradeId: ['', []],
            TargetClientOrderId: ['', []],
            TargetOrderSource: ['', []],

            TargetTradePrice: ['', [ Validators.required, Validators.min(0)]],
            TargetTradeQuantity: ['', [Validators.required, Validators.min(0)]],
            TargetTradeAmount: ['', [Validators.required, Validators.min(0)]],
            TargetTradeTS: ['', []],
            TargetTradeDate: ['', []],
            TargetFee: ['0', []],
            TargetFeeCurrency: ['', []],
            CommentText: ['', []],
        });

        this.data.TargetSide = this.data.SourceSide == 'BUY' ? 'SELL' : 'BUY'; 
        this.getExchangeList();
    }

    //  Get exchanges
    getExchangeList() {
        this.userService.getExchanges().subscribe(response => {
            let data = response.map(function (item) {
                return { exchange: item.ExchangeName };
            })
            this.exchangeList = data.filter(name => name.exchange != 'BEST');
        })
    }

    editAdminTradeMaster() {
        const { notif } = defaults;
        try {
            if (this.adminTradeMasterForm.valid) {
                this.userService.csrf().subscribe(success => {
                    this.adminTradeMasterForm.value['_csrf'] = success['_csrf'];
                    this.adminTradeMasterForm.value['_id'] = this.data._id;

                    this.adminTradeMasterForm.value['Pair'] = this.data.Pair;
                    this.adminTradeMasterForm.value['BaseCurrency'] = this.data.BaseCurrency;
                    this.adminTradeMasterForm.value['QuoteCurrency'] = this.data.QuoteCurrency;
                    this.adminTradeMasterForm.value['SourceTradePrice'] = this.data.SourceTradePrice;
                    this.adminTradeMasterForm.value['SourceTradeQuantity'] = this.data.SourceTradeQuantity;
                    this.adminTradeMasterForm.value['SourceTradeAmount'] = this.data.SourceTradeAmount;
                    this.adminTradeMasterForm.value['SourceClientOrderId'] = this.data.SourceClientOrderId;
                    this.adminTradeMasterForm.value['SourceOrderSource'] = this.data.SourceOrderSource;
                    this.adminTradeMasterForm.value['SourceTradeTS'] = this.data.SourceTradeTS;
                    this.adminTradeMasterForm.value['SourceTradeDate'] = this.data.SourceTradeDate;
                    // this.adminTradeMasterForm.value['SourceSide'] = this.data.SourceSide;
                    // this.adminTradeMasterForm.value['SourceUserEmail'] = this.data.SourceUserEmail;

                    this.adminTradeMasterForm.value['TargetExchange'] = this.data.TargetExchange;

                    this.adminTradeMasterForm.value['TargetSide'] = this.data.TargetSide;
                    this.adminTradeMasterForm.value['TargetOrderId'] = this.data.TargetOrderId;
                    this.adminTradeMasterForm.value['TargetTradeId'] = this.data.TargetTradeId;
                    this.adminTradeMasterForm.value['TargetClientOrderId'] = this.data.TargetClientOrderId;
                    this.adminTradeMasterForm.value['TargetOrderSource'] = this.data.TargetOrderSource;
                    this.adminTradeMasterForm.value['TargetTradePrice'] = this.data.TargetTradePrice;
                    this.adminTradeMasterForm.value['TargetTradeQuantity'] = this.data.TargetTradeQuantity;
                    this.adminTradeMasterForm.value['TargetTradeAmount'] = this.data.TargetTradeAmount;
                    this.adminTradeMasterForm.value['TargetTradeDate'] = this.data.TargetTradeDate;
                    this.adminTradeMasterForm.value['TargetFee'] = this.data.TargetFee;
                    this.adminTradeMasterForm.value['TargetFeeCurrency'] = this.data.TargetFeeCurrency;
                    this.adminTradeMasterForm.value['CommentTex'] = this.data.CommentTex;
                    
                    this.reportService.editAdminTradeMaster(this.adminTradeMasterForm.value).subscribe(response => {
                        if (response.status) {
                            this.notifSer.success('Success', response.message, notif)
                            // Emit the form data when closing the dialog
        
                            this.dialogRef.close({ success: true, data: response.message });
        
                        } else this.notifSer.error('Error', response.message, notif);
                    }, err => this.notifSer.error('Error', err.error.message, notif))
                })
            }else{
                this.notifSer.error('Error', 'Please select user', notif)
            }
        } catch (error) {

        }
    }

    updateAmount() {
        if(this.data.TargetTradePrice !== '' && this.data.TargetTradeQuantity !== '' ){
            this.data.TargetTradeAmount = Number(this.data.TargetTradePrice) * this.data.TargetTradeQuantity
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/admintrademaster/edit-admin-trade-master/edit-admin-trade-master.component.ts